module.exports = __webpack_public_path__ + "12c23e399d206b7228033d3a2b64f07c.bg-main-mobile.webp";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg-main-mobile.webp
// module id = 7qw7
// module chunks = 0